import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/dashboard.css";
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components";
import Calendar from "react-calendar";
import { useAuthContext } from '../../common/ProtectedLayout';
import "react-calendar/dist/Calendar.css";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function Biling(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuthContext();

    // ✅ [추가] 모달 제어를 위한 ref 생성
    const modalCorrective = useRef(); // 기존 상세 모달
    const modalGallery = useRef();    // 갤러리 모달
    const modalImageViewer = useRef(); // 이미지 확대 모달
    const modalSelection = useRef();   // ✅ [New] 예약번호 선택 모달
    const modalOrderList = useRef(); // ✅ 오더 리스트 모달 Ref 추가

    // --- 상태 관리 ---
    const [isValidAccess, setIsValidAccess] = useState(false);
    const [bilingList, setBilingList] = useState([]);
    const [records, setRecords] = useState({});

    // 달력의 현재 뷰 기준일 (월 이동 감지용)
    const [activeStartDate, setActiveStartDate] = useState(new Date());

    const [filters, setFilters] = useState({
        신청: true,
        완료: true,
        반려: true
    });

    // ✅ 오더 리스트 상태 추가
    const [orderListState, setOrderListState] = useState({
        isOpen: false,
        orders: []
    });

    const [page, setPage] = useState(1);
    const items = 10;
    const [selectedDate, setSelectedDate] = useState(new Date());

    const [selectedBiling, setSelectedBiling] = useState(null);
    const [viewImage, setViewImage] = useState(null); // 이미지 확대 모달용

    // 갤러리 모달용 상태
    const [galleryState, setGalleryState] = useState({
        isOpen: false,
        type: '',
        images: [],
        userId: '',
        reservationId: ''
    });

    const [bilingCount, setBilingCount] = useState(0);

    // ✅ [New] 예약번호가 여러 개일 때 선택 모달 상태
    const [selectionState, setSelectionState] = useState({
        isOpen: false,
        type: '', // '완료사진' or 'A/S자료'
        reqNumbers: [] // 선택 가능한 예약번호 리스트
    });

    // 달력 타일용 날짜 포맷 (YYYY-MM-DD)
    const getFormatDateKey = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    // 1. 월별 통계 조회
    const getMonthStatus = useCallback(async (date) => {
        try {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const result = await axios.get(`/PayoutList/MonthStatus/${year}/${month}`);

            if (result.data.success) {
                const data = result.data.message;
                const newRecords = {};

                data.forEach(item => {
                    let dateKey = item.regi_date;
                    if (typeof dateKey === 'string' && dateKey.includes('T')) {
                        dateKey = dateKey.split('T')[0];
                    }

                    if (!newRecords[dateKey]) {
                        newRecords[dateKey] = { 신청: 0, 완료: 0, 반려: 0 };
                    }
                    if (item.payout_state) {
                        newRecords[dateKey][item.payout_state] = item.count;
                    }
                });
                setRecords(newRecords);
            }
        } catch (error) {
            console.error("Calendar fetch error:", error);
            setRecords({});
        }
    }, []);

    // 2. 상세 리스트 조회
    // ✅ [성능 개선] 서버에서 매니저 정보를 JOIN으로 함께 반환하므로, 추가 API 호출 불필요
    const getBilingRegist = useCallback(async (dateObj, currentPage) => {
        try {
            const formattedDate = getFormatDateKey(dateObj);
            const pageParam = currentPage - 1;
            const payoutResult = await axios.get(`/PayoutList/admin/${formattedDate}/${pageParam}`);
            const payoutData = payoutResult.data.message;

            if (!payoutData || payoutData.length === 0) {
                setBilingList([]);
                return;
            }

            // ✅ [N+1 쿼리 해결] 서버에서 이미 매니저 정보를 JOIN하여 전달 (name, bank, bank_num)
            // 기존: 각 item마다 axios.get('/ManagerRegist/EmailID/...') 호출 (10건 = 10번 추가 API)
            // 개선: 서버 응답 데이터를 그대로 사용 (추가 API 호출 0번)
            const combinedList = payoutData.map((item) => ({
                ...item,
                mg_name: item.name || "정보없음",           // 서버 JOIN 결과 사용
                bank: item.bank || "",                      // 서버 JOIN 결과 사용
                bank_number: item.bank_num || "",           // 서버 JOIN 결과 사용
                confirm_photo: item.confirm_picture || item.comfirm_picture || null,
                confirm_as: item.confirm_as || item.comfirm_as || null,
                confirm_paper: item.confirm_import || item.comfirm_import || null,
                description: item.description || "",
                reservation_no: item.list ? item.list.split(',')[0].trim() : item.number,
                tax_invoice_img: item.tax_invoice_img || null
            }));

            setBilingList(combinedList);
        } catch (error) {
            console.error("Biling list fetch error:", error);
            setBilingList([]);
        }
    }, []);

    // 전체 개수 조회
    const getBilingCount = useCallback(async (dateObj) => {
        try {
            const formattedDate = getFormatDateKey(dateObj);
            const res = await axios.get(`/PayoutList/adminCount/${formattedDate}`);
            if (res.data.success) {
                setBilingCount(res.data.count);
            }
        } catch (error) {
            console.error("Count fetch error:", error);
            setBilingCount(0);
        }
    }, []);

    const filteredBilingList = bilingList.filter(item => {
        const state = item.payout_state;
        if (filters[state] !== undefined) return filters[state];
        return true;
    });

    // --- 이벤트 핸들러 ---
    const handleDateClick = (value) => {
        setSelectedDate(value);
        setActiveStartDate(value);
        setPage(1);
    };

    const handleActiveStartDateChange = ({ activeStartDate, view }) => {
        if (view === 'month') setActiveStartDate(activeStartDate);
    };

    const handlePageChange = (page) => { setPage(page); };

    const handleRowClick = async (item) => {
        // 1. 기본 선택 상태 설정
        // 초기에는 AS 정보가 없으므로 빈 배열로 설정
        const initialItem = { ...item, as_list: [], as_exist: false };
        setSelectedBiling(initialItem);

        // 2. 모달 열기
        modalCorrective.current.showModal();

        // 3. AS 정보 비동기 조회 (매니저 ID 기반)
        if (item.manager_id) {
            try {
                const res = await axios.get(`/AsRegistID/${item.manager_id}`);
                if (res.data.success && res.data.message.length > 0) {
                    const asHistory = res.data.message; // AS 등록 내역 전체

                    // 현재 정산 건에 포함된 예약번호 목록 추출
                    let currentReqNumbers = [];
                    if (item.list) {
                        currentReqNumbers = item.list.split(',').map(str => str.trim()).filter(str => str !== "");
                    } else {
                        currentReqNumbers = [item.number];
                    }

                    // AS 내역 중 현재 정산 건에 포함된 것만 필터링 (req_number 기준 매칭)
                    // as_regist 테이블의 req_number와 payout_list의 예약번호 매칭
                    const matchedAS = asHistory.filter(asItem => currentReqNumbers.includes(asItem.req_number));
                    const matchedASList = [...new Set(matchedAS.map(asItem => asItem.req_number))];

                    // 상태 업데이트
                    setSelectedBiling(prev => ({
                        ...prev,
                        as_list: matchedASList,
                        as_exist: matchedASList.length > 0
                    }));
                }
            } catch (error) {
                console.error("AS History fetch error:", error);
                // 에러 발생 시 AS 없음으로 처리 (기본값 유지)
            }
        }
    };

    const toggleFilter = (status) => {
        setFilters(prev => ({ ...prev, [status]: !prev[status] }));
    };

    const handleConfirm = async (type) => {
        if (!selectedBiling) return;

        // ✅ [Updated] 관리자일 경우 "관리자", 그 외에는 로그인 ID 사용
        const confirmerName = auth.loginId === 'admin' ? "관리자" : auth.loginId;

        const url = "/Payout/ConfirmUpdate";
        // ✅ [Updated] number 대신 idx 사용 (number는 중복 가능성 있음)
        let body = { idx: selectedBiling.idx };
        let stateKey = "";

        if (type === 'photo') {
            body.confirm_picture = confirmerName;
            stateKey = "confirm_photo";
        } else if (type === 'as') {
            body.confirm_as = confirmerName;
            stateKey = "confirm_as";
        } else if (type === 'paper') {
            body.confirm_import = confirmerName;
            stateKey = "confirm_paper";
        }

        try {
            const res = await axios.patch(url, body);
            if (res.data.success) {
                const updatedBiling = { ...selectedBiling, [stateKey]: confirmerName };
                setSelectedBiling(updatedBiling);
                setBilingList(prevList => prevList.map(item =>
                    item.idx === selectedBiling.idx ? updatedBiling : item
                ));
            } else {
                alert("수정에 실패했습니다: " + res.data.message);
            }
        } catch (error) {
            console.error("Update failed:", error);
            alert("업데이트 중 오류가 발생했습니다.");
        }
    };

    // ✅ [Updated] 반려 처리 시 오더 미출금 상태 전환 로직 추가
    const handleStatusChange = async (newStatus) => {
        if (!selectedBiling) return;
        let description = "";

        if (newStatus === "반려") {
            description = prompt("반려 사유를 입력해주세요.");
            if (description === null) return;
            if (description.trim() === "") {
                alert("반려 사유를 입력해야 합니다.");
                return;
            }
        } else if (newStatus === "완료") {
            if (!window.confirm("지급 처리를 완료하시겠습니까?")) return;
        }

        // 1. 정산 리스트 상태 업데이트 (PayoutList)
        const urlConfirm = "/Payout/ConfirmUpdate";
        const bodyConfirm = {
            idx: selectedBiling.idx, // ✅ [Updated] number -> idx
            payout_state: newStatus,
            description: description
        };

        try {
            const resConfirm = await axios.patch(urlConfirm, bodyConfirm);

            if (resConfirm.data.success) {

                // ✅ 2. '반려'일 경우, 포함된 오더들을 미출금 상태로 초기화 (API 호출)
                if (newStatus === "반려") {
                    try {
                        // list(여러 오더)가 있으면 list를, 없으면 number(단일 오더)를 보냄
                        const reqNumPayload = selectedBiling.list ? selectedBiling.list : selectedBiling.number;
                        const urlCompanion = "/Payout/Companion";
                        const bodyCompanion = { req_num: reqNumPayload };

                        // 오더 초기화 API 호출
                        const resCompanion = await axios.put(urlCompanion, bodyCompanion);
                        console.log("오더 초기화 결과:", resCompanion.data.message);

                    } catch (err) {
                        console.error("오더 초기화 실패:", err);
                        alert("정산 상태는 반려로 변경되었으나, 오더 초기화 중 오류가 발생했습니다.");
                    }
                }

                alert(`${newStatus} 처리가 완료되었습니다.`);
                modalCorrective.current.close();
                getBilingRegist(selectedDate, page);
                getMonthStatus(activeStartDate);
            } else {
                alert("처리 실패: " + resConfirm.data.message);
            }
        } catch (error) {
            console.error("Status update failed:", error);
            alert("처리 중 오류가 발생했습니다.");
        }
    };

    // ✅ [Updated] 실제 이미지를 불러오고 갤러리를 여는 공통 함수
    const fetchAndOpenGallery = async (targetReqNum, type) => {
        try {
            // 선택 모달이 열려있다면 닫기
            setSelectionState(prev => ({ ...prev, isOpen: false }));

            // 1. 사용자 ID 조회
            const userRes = await axios.get(`/Reservation/UserInfo/ReservationNum/${targetReqNum}`);
            const userId = userRes.data[0]?.user_id;

            if (!userId) {
                alert(`예약번호(${targetReqNum})의 사용자 정보를 찾을 수 없습니다.`);
                return;
            }

            let apiUrl = "";
            let galleryType = "";

            // 2. API 경로 설정
            if (type === '완료사진') {
                apiUrl = `/imagesName/work_process/${userId}/${targetReqNum}`;
                galleryType = 'work';
            } else if (type === 'A/S자료') {
                apiUrl = `/imagesName/as_complete/${userId}/${targetReqNum}`;
                galleryType = 'as';
            }

            // 3. 이미지 목록 조회
            const imgRes = await axios.get(apiUrl);

            if (imgRes.data.success) {
                const imageNames = imgRes.data.images || [];
                // ✅ [수정] 빈 배열일 경우 명확한 메시지 출력
                if (imageNames.length === 0) {
                    alert("등록된 사진 내역이 없습니다.");
                    return;
                }

                // 4. 갤러리 열기
                setGalleryState({
                    isOpen: true,
                    type: galleryType,
                    images: imageNames,
                    userId: userId,
                    reservationId: targetReqNum
                });
            } else {
                // success가 false인 경우 (보통 발생하지 않지만 대비용)
                alert("등록된 사진 내역이 없습니다.");
            }
        } catch (error) {
            console.error("Image fetch error:", error);
            // ✅ [수정] 404(Not Found)나 500(폴더 읽기 실패)일 때 "등록된 내역 없음"으로 안내
            if (error.response && (error.response.status === 404 || error.response.status === 500)) {
                alert("등록된 사진 내역이 없습니다.");
            } else {
                alert("이미지를 불러오는 중 오류가 발생했습니다.");
            }
        }
    };

    // ✅ [Updated] 세금계산서 이미지(수입자료) 불러오기 - 매니저 경로 사용
    const fetchAndOpenTaxImage = async (payoutNum, managerId) => {
        try {
            if (!managerId) {
                alert("매니저 정보를 찾을 수 없습니다.");
                return;
            }

            // 매니저가 업로드한 세금계산서 이미지 경로
            const imageUrl = `/image/manager/tax/${managerId}/${payoutNum}`;

            // 이미지 존재 여부 확인
            try {
                await axios.get(imageUrl);
                setViewImage(imageUrl);
            } catch (err) {
                alert("등록된 수입자료(세금계산서) 이미지가 없습니다.");
            }

        } catch (error) {
            console.error("Tax image fetch error:", error);
            alert("이미지를 불러오는 중 오류가 발생했습니다.");
        }
    };

    // 첨부파일 보기 핸들러
    const handleViewAttachment = async (type) => {
        if (!selectedBiling) return;

        if (type === '수입자료') {
            // 정산번호 (원장번호)
            const payoutNum = selectedBiling.number;
            // 매니저 ID (이메일)
            const managerId = selectedBiling.manager_id;

            fetchAndOpenTaxImage(payoutNum, managerId);
            return;
        }

        // 1. 예약번호 목록 추출
        let reqNumbers = [];
        // ✅ [Updated] A/S 자료인 경우, 서버에서 필터링해준 as_list 사용
        if (type === 'A/S자료' && selectedBiling.as_list && selectedBiling.as_list.length > 0) {
            reqNumbers = selectedBiling.as_list;
        } else if (selectedBiling.list) {
            reqNumbers = selectedBiling.list.split(',').map(str => str.trim()).filter(str => str !== "");
        } else {
            reqNumbers = [selectedBiling.number];
        }

        // B공고 필터링 (사진첨부 없음)
        reqNumbers = reqNumbers.filter(num => !num.startsWith('B'));

        // 2. 개수에 따른 분기
        if (reqNumbers.length === 1) {
            fetchAndOpenGallery(reqNumbers[0], type);
        } else if (reqNumbers.length > 1) {
            setSelectionState({
                isOpen: true,
                type: type,
                reqNumbers: reqNumbers
            });
        } else {
            alert("예약 번호가 존재하지 않습니다.");
        }
    };

    const closeGallery = () => {
        setGalleryState({ isOpen: false, type: '', images: [], userId: '', reservationId: '' });
    };

    // ✅ 오더 리스트 보기 핸들러
    const handleViewOrderList = () => {
        if (!selectedBiling) return;

        // list가 없으면 포함된 오더 정보가 없음
        if (!selectedBiling.list) {
            alert("포함된 오더 정보가 없습니다.");
            return;
        }

        const orders = selectedBiling.list.split(',').map(str => str.trim()).filter(str => str !== "");

        if (orders.length === 0) {
            alert("포함된 오더 정보가 없습니다.");
            return;
        }

        setOrderListState({
            isOpen: true,
            orders: orders
        });
    };

    // ✅ 오더 상세 이동 핸들러
    const handleOrderClick = async (reqNum) => {
        // 모달 닫기
        setOrderListState({ isOpen: false, orders: [] });
        modalCorrective.current.close();

        // B공고 분기 처리
        if (reqNum.startsWith('B')) {
            try {
                const res = await axios.get(`/NoticeList/ByReqNumber/${reqNum}`);
                if (res.data.success && res.data.idx) {
                    navigate('/noticelist_detail', { state: { idx: res.data.idx, beforePage: '/biling' } });
                } else {
                    alert('해당 공고를 찾을 수 없습니다.');
                }
            } catch (error) {
                alert('공고 조회 중 오류가 발생했습니다.');
            }
        } else {
            // 기존 R예약 처리
            navigate('/listdetail', { state: { req_number: reqNum, beforePage: '/biling' } });
        }
    };

    const isAllConfirmed =
        selectedBiling?.confirm_photo &&
        selectedBiling?.confirm_as &&
        selectedBiling?.confirm_paper;

    const isFinished =
        selectedBiling?.payout_state === "반려" ||
        selectedBiling?.payout_state === "완료";

    // --- useEffect ---

    useEffect(() => {
        if (galleryState.isOpen && modalGallery.current) {
            modalGallery.current.showModal();
        } else if (!galleryState.isOpen && modalGallery.current) {
            modalGallery.current.close();
        }
    }, [galleryState.isOpen]);

    useEffect(() => {
        if (viewImage && modalImageViewer.current) {
            modalImageViewer.current.showModal();
        } else if (!viewImage && modalImageViewer.current) {
            modalImageViewer.current.close();
        }
    }, [viewImage]);

    useEffect(() => {
        if (selectionState.isOpen && modalSelection.current) {
            modalSelection.current.showModal();
        } else if (!selectionState.isOpen && modalSelection.current) {
            modalSelection.current.close();
        }
    }, [selectionState.isOpen]);

    // ✅ 오더 리스트 모달 제어
    useEffect(() => {
        if (orderListState.isOpen && modalOrderList.current) {
            modalOrderList.current.showModal();
        } else if (!orderListState.isOpen && modalOrderList.current) {
            modalOrderList.current.close();
        }
    }, [orderListState.isOpen]);

    useEffect(() => {
        setIsValidAccess(true);
    }, []);

    useEffect(() => {
        // 날짜가 변경되거나 페이지가 변경될 때 데이터 조회
        getBilingRegist(selectedDate, page);
        getBilingCount(selectedDate);
    }, [selectedDate, page, getBilingRegist, getBilingCount]);

    useEffect(() => {
        if (activeStartDate) {
            getMonthStatus(activeStartDate);
        }
    }, [activeStartDate, getMonthStatus]);

    if (!isValidAccess) return null;

    const tileContent = ({ date, view }) => {
        if (view !== 'month') return null;
        const dateKey = getFormatDateKey(date);
        const data = records[dateKey];
        if (!data) return null;

        return (
            <div className="marker-container">
                {filters.신청 && data.신청 > 0 && <div className="calendar-marker marker-apply">신청 {data.신청}</div>}
                {filters.완료 && data.완료 > 0 && <div className="calendar-marker marker-complete">완료 {data.완료}</div>}
                {filters.반려 && data.반려 > 0 && <div className="calendar-marker marker-reject">반려 {data.반려}</div>}
            </div>
        );
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <FilterContainer>
                    <label className="checkbox-label"><input type="checkbox" checked={filters.신청} onChange={() => toggleFilter('신청')} /><span className="indicator apply"></span> 정산신청</label>
                    <label className="checkbox-label"><input type="checkbox" checked={filters.완료} onChange={() => toggleFilter('완료')} /><span className="indicator complete"></span> 정산완료</label>
                    <label className="checkbox-label"><input type="checkbox" checked={filters.반려} onChange={() => toggleFilter('반려')} /><span className="indicator reject"></span> 정산반려</label>
                </FilterContainer>

                <CalendarWrapper>
                    <Calendar
                        locale="ko-KR"
                        calendarType="gregory"
                        activeStartDate={activeStartDate}
                        onActiveStartDateChange={handleActiveStartDateChange}
                        value={selectedDate}
                        onChange={handleDateClick}
                        tileContent={tileContent}
                        formatDay={(locale, date) => date.getDate()}
                        prev2Label={null}
                        next2Label={null}
                    />
                </CalendarWrapper>

                <div style={{ marginTop: '30px' }}>
                    <CommonTable headerTitle={['No', '매니저이름', '은행명', '계좌번호', '원장번호', '포함된 오더', '공급가액', '부가세', '완료사진', 'A/S', '수입자료', '출금신청일자', '상태']}>
                        {filteredBilingList.length > 0 ? (
                            filteredBilingList.map((item, index) => (
                                <CommonTableRow key={index} idx={item.idx} beforePage={'/biling'} kind={'notDetail'} onClick={() => handleRowClick(item)}>
                                    <CommonTableColumn>{bilingCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                    <CommonTableColumn>{item.name}</CommonTableColumn>
                                    <CommonTableColumn>{item.bank}</CommonTableColumn>
                                    <CommonTableColumn>{item.bank_number}</CommonTableColumn>
                                    <CommonTableColumn>{item.number}</CommonTableColumn>
                                    <CommonTableColumn>
                                        {item.list && item.list.length > 20 ? item.list.substring(0, 20) + "..." : item.list}
                                    </CommonTableColumn>
                                    <CommonTableColumn>{Math.round(Number(String(item.total_payment).replace(/[^0-9]/g, '')) / 1.1).toLocaleString()}</CommonTableColumn>
                                    <CommonTableColumn>{(Number(String(item.total_payment).replace(/[^0-9]/g, '')) - Math.round(Number(String(item.total_payment).replace(/[^0-9]/g, '')) / 1.1)).toLocaleString()}</CommonTableColumn>
                                    <CommonTableColumn>{item.confirm_photo ? <span style={{ color: 'blue', fontWeight: 'bold' }}>{item.confirm_photo}</span> : "-"}</CommonTableColumn>
                                    <CommonTableColumn>{item.confirm_as ? <span style={{ color: 'blue', fontWeight: 'bold' }}>{item.confirm_as}</span> : "-"}</CommonTableColumn>
                                    <CommonTableColumn>{item.confirm_paper ? <span style={{ color: 'blue', fontWeight: 'bold' }}>{item.confirm_paper}</span> : "-"}</CommonTableColumn>
                                    <CommonTableColumn>{item.regi_date}</CommonTableColumn>
                                    <CommonTableColumn><span style={{ fontWeight: 'bold', color: item.payout_state === '신청' ? '#006edc' : item.payout_state === '완료' ? '#28a745' : item.payout_state === '반려' ? '#dc3545' : 'black' }}>{item.payout_state}</span></CommonTableColumn>
                                </CommonTableRow>
                            ))
                        ) : (
                            <tr><td colSpan="12" style={{ textAlign: "center", padding: "20px" }}>해당 조건의 내역이 없습니다.</td></tr>
                        )}
                    </CommonTable>
                </div>

                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={bilingCount}
                        pageRangeDisplayed={10}
                        onChange={handlePageChange}
                    />
                </PaginationBox>
            </div>

            {/* 상세 모달 */}
            <dialog ref={modalCorrective} style={{ borderRadius: '12px', border: 'none', width: '600px', padding: '0', boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}>
                <div style={{ padding: '20px 30px', maxHeight: '80vh', overflowY: 'auto' }}>
                    <h3 style={{ textAlign: 'center', marginBottom: '25px', fontSize: '1.3rem', fontWeight: 'bold' }}>출금 신청 상세</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <DetailRow label="원장번호" value={selectedBiling?.number} />
                        <DetailRow label="매니저이름" value={selectedBiling?.mg_name} />
                        <DetailRow label="은행이름" value={selectedBiling?.bank} />
                        <DetailRow label="계좌번호" value={selectedBiling?.bank_number} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label style={{ width: '30%', fontWeight: 'bold', color: '#555', fontSize: '0.95rem' }}>포함된 오더</label>
                            <div style={{ width: '65%', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontSize: '0.95rem', color: '#333' }}>
                                    {selectedBiling?.list ? (selectedBiling.list.length > 30 ? selectedBiling.list.substring(0, 30) + "..." : selectedBiling.list) : selectedBiling?.number}
                                </span>
                                <button
                                    onClick={handleViewOrderList}
                                    style={{
                                        padding: '4px 10px',
                                        backgroundColor: '#006edc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    보기
                                </button>
                            </div>
                        </div>
                        <DetailRow label="공급가액" value={selectedBiling ? Math.round(Number(String(selectedBiling.total_payment).replace(/[^0-9]/g, '')) / 1.1).toLocaleString() : '-'} />
                        <DetailRow label="부가세" value={selectedBiling ? (Number(String(selectedBiling.total_payment).replace(/[^0-9]/g, '')) - Math.round(Number(String(selectedBiling.total_payment).replace(/[^0-9]/g, '')) / 1.1)).toLocaleString() : '-'} />
                        <DetailRow label="합계금" value={selectedBiling?.total_payment} isBold color="#006edc" />
                        <DetailRow label="출금신청일자" value={selectedBiling?.regi_date} />
                        <DetailRow label="현재상태" value={selectedBiling?.payout_state} isBold color={selectedBiling?.payout_state === '반려' ? '#dc3545' : 'black'} />
                    </div>

                    {selectedBiling?.payout_state === '반려' && (
                        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '10px', borderLeft: '5px solid #dc3545' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '5px' }}>반려 사유</div>
                            <div style={{ fontSize: '0.95rem', color: '#333', lineHeight: '1.4', whiteSpace: 'pre-wrap' }}>{selectedBiling?.description || "사유 없음"}</div>
                        </div>
                    )}

                    <hr style={{ margin: '20px 0', border: '0', borderTop: '1px solid #eee' }} />

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <ConfirmRow label="완료유무-확인자" confirmer={selectedBiling?.confirm_photo} onConfirm={() => handleConfirm('photo')} onView={() => handleViewAttachment('완료사진')} />
                        <ConfirmRow
                            label="A/S유무-확인자"
                            confirmer={selectedBiling?.confirm_as}
                            onConfirm={() => handleConfirm('as')}
                            onView={() => handleViewAttachment('A/S자료')}
                            showViewButton={selectedBiling?.as_list && selectedBiling.as_list.length > 0}
                        />
                        <ConfirmRow label="수입자료-확인자" confirmer={selectedBiling?.confirm_paper} onConfirm={() => handleConfirm('paper')} onView={() => handleViewAttachment('수입자료')} />
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 30px', backgroundColor: '#f9f9f9', borderTop: '1px solid #eee', borderRadius: '0 0 12px 12px' }}>
                    <button onClick={() => modalCorrective.current.close()} style={{ padding: '10px 30px', backgroundColor: 'white', color: '#333', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>취소</button>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button onClick={() => handleStatusChange("반려")} disabled={isFinished} style={{ padding: '10px 30px', backgroundColor: isFinished ? '#f0f0f0' : 'white', color: isFinished ? '#aaa' : '#dc3545', border: '1px solid ' + (isFinished ? '#ccc' : '#dc3545'), borderRadius: '6px', cursor: isFinished ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}>반려</button>
                        <button onClick={() => handleStatusChange("완료")} disabled={!isAllConfirmed || isFinished} style={{ padding: '10px 30px', backgroundColor: (!isAllConfirmed || isFinished) ? '#f0f0f0' : '#006edc', color: (!isAllConfirmed || isFinished) ? '#aaa' : 'white', border: '1px solid ' + ((!isAllConfirmed || isFinished) ? '#ccc' : '#006edc'), borderRadius: '6px', cursor: (!isAllConfirmed || isFinished) ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}>지급</button>
                    </div>
                </div>
            </dialog>

            {/* ✅ [New] 예약번호 선택 모달 */}
            <dialog
                ref={modalSelection}
                onClose={() => setSelectionState(prev => ({ ...prev, isOpen: false }))}
                style={{
                    padding: '20px',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    minWidth: '300px',
                    textAlign: 'center',
                    zIndex: 2000
                }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '1.1rem', fontWeight: 'bold' }}>예약 번호 선택</h3>
                <p style={{ marginBottom: '20px', fontSize: '0.9rem', color: '#666' }}>확인할 예약 번호를 선택해주세요.</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {selectionState.reqNumbers.map((num, idx) => (
                        <button
                            key={idx}
                            onClick={() => fetchAndOpenGallery(num, selectionState.type)}
                            style={{
                                padding: '12px',
                                backgroundColor: '#f0f8ff',
                                border: '1px solid #006edc',
                                borderRadius: '8px',
                                color: '#006edc',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                transition: 'background 0.2s'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e1f0ff'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                        >
                            {num}
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => setSelectionState(prev => ({ ...prev, isOpen: false }))}
                    style={{
                        marginTop: '20px',
                        padding: '8px 20px',
                        backgroundColor: '#eee',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    취소
                </button>
            </dialog>

            {/* ✅ [New] 오더 리스트 모달 */}
            <dialog
                ref={modalOrderList}
                onClose={() => setOrderListState(prev => ({ ...prev, isOpen: false }))}
                style={{
                    padding: '20px',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    minWidth: '300px',
                    textAlign: 'center',
                    zIndex: 2000
                }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '1.1rem', fontWeight: 'bold' }}>포함된 오더 목록</h3>
                <p style={{ marginBottom: '20px', fontSize: '0.9rem', color: '#666' }}>상세 정보를 볼 오더를 선택해주세요.</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
                    {orderListState.orders.map((num, idx) => (
                        <button
                            key={idx}
                            onClick={() => handleOrderClick(num)}
                            style={{
                                padding: '12px',
                                backgroundColor: '#fff',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                color: '#333',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#f0f8ff';
                                e.target.style.borderColor = '#006edc';
                                e.target.style.color = '#006edc';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.borderColor = '#ddd';
                                e.target.style.color = '#333';
                            }}
                        >
                            {num}
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => setOrderListState(prev => ({ ...prev, isOpen: false }))}
                    style={{
                        marginTop: '20px',
                        padding: '8px 20px',
                        backgroundColor: '#eee',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    닫기
                </button>
            </dialog>

            {/* 갤러리 모달 (Dialog로 변경 + 스크롤 고침) */}
            <dialog
                ref={modalGallery}
                onClose={closeGallery}
                style={{
                    padding: 0,
                    border: 'none',
                    borderRadius: '12px',
                    width: '80%',
                    maxWidth: '900px',
                    height: '80vh',
                    maxHeight: '90vh',
                    boxShadow: '0 5px 30px rgba(0,0,0,0.3)',
                    backgroundColor: 'transparent',
                    overflow: 'hidden'
                }}
            >
                {/* dialog 내부 컨테이너 */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    height: '100%',
                    width: '100%'
                }}>
                    {/* 헤더 (고정) */}
                    <div style={{ padding: '15px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', flexShrink: 0 }}>
                        <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 'bold' }}>
                            {galleryState.type === 'work' ? '완료 사진 (16장)' : 'A/S 완료 사진 (4장)'}
                        </h3>
                        <button onClick={closeGallery} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}>✕</button>
                    </div>

                    {/* 내용 (스크롤 영역) */}
                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '20px',
                        backgroundColor: '#fff',
                        minHeight: 0
                    }}>
                        {galleryState.images.length > 0 && (
                            <GalleryGrid
                                type={galleryState.type}
                                images={galleryState.images}
                                userId={galleryState.userId}
                                reservationId={galleryState.reservationId}
                                onImageClick={setViewImage}
                            />
                        )}
                    </div>

                    {/* 하단 확인 버튼 영역 (고정) */}
                    <div style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'center', backgroundColor: '#f9f9f9', flexShrink: 0 }}>
                        <button
                            onClick={closeGallery}
                            style={{
                                padding: '10px 40px',
                                backgroundColor: '#006edc',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </dialog>

            {/* 단일 이미지 확대 뷰어 (모달 형태) */}
            <dialog
                ref={modalImageViewer}
                onClose={() => setViewImage(null)}
                style={{
                    width: '80%',
                    maxWidth: '900px',
                    height: '80vh',
                    maxHeight: '90vh',
                    backgroundColor: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: 0,
                    boxShadow: '0 5px 30px rgba(0,0,0,0.3)',
                    overflow: 'hidden'
                }}
            >
                {viewImage && (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        {/* 헤더 */}
                        <div style={{
                            padding: '15px 20px',
                            borderBottom: '1px solid #eee',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            flexShrink: 0
                        }}>
                            <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 'bold' }}>세금계산서</h3>
                            <button onClick={() => setViewImage(null)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}>✕</button>
                        </div>
                        {/* 이미지 영역 */}
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', backgroundColor: '#f5f5f5', overflow: 'auto' }}>
                            <TransformWrapper initialScale={1}>
                                <TransformComponent wrapperStyle={{ width: "100%", height: "100%" }}>
                                    <img src={viewImage} alt="세금계산서" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                </TransformComponent>
                            </TransformWrapper>
                        </div>
                        {/* 하단 버튼 */}
                        <div style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'center', backgroundColor: '#f9f9f9', flexShrink: 0 }}>
                            <button
                                onClick={() => setViewImage(null)}
                                style={{
                                    padding: '10px 40px',
                                    backgroundColor: '#006edc',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                )}
            </dialog>
        </div>
    );
}


const GalleryGrid = ({ type, images, userId, reservationId, onImageClick }) => {
    // 백엔드 API 경로 규칙에 맞춰 이미지 URL 생성 함수 정의
    // work -> /imagesRead/work_process/...
    // as   -> /imagesRead/as_complete/...
    const getSrc = (imgName) => {
        const pathType = type === 'work' ? 'work_process' : 'as_complete';
        return `/imagesRead/${pathType}/${userId}/${reservationId}/${imgName}`;
    };

    // [CASE 1] 완료사진 (16장 - 작업 과정)
    // 전/후 사진을 비교해서 보여주기 위해 2열 그리드 사용
    if (type === 'work') {
        const labels = ["필터그릴", "필터", "프론트", "드레인 판", "핀 세척", "송풍팬", "스티커", "복장체크"];

        // 파일명을 이름순으로 정렬 (보통 01_before, 01_after 식으로 저장되므로 정렬하면 짝이 맞음)
        const sortedImages = [...images].sort();

        return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                {labels.map((label, rowIdx) => {
                    // 짝수 인덱스: 전(Before), 홀수 인덱스: 후(After)
                    const imgBefore = sortedImages[rowIdx * 2];
                    const imgAfter = sortedImages[rowIdx * 2 + 1];

                    return (
                        <React.Fragment key={rowIdx}>
                            <ImageCard
                                label={`${label} (전)`}
                                src={imgBefore ? getSrc(imgBefore) : null}
                                onClick={onImageClick}
                            />
                            <ImageCard
                                label={`${label} (후)`}
                                src={imgAfter ? getSrc(imgAfter) : null}
                                onClick={onImageClick}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
    // [CASE 2] A/S 자료 (4장 등)
    // 단순 나열 방식
    else {
        return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                {images.map((imgName, idx) => (
                    <ImageCard
                        key={idx}
                        label={`AS 완료사진 ${idx + 1}`}
                        src={getSrc(imgName)}
                        onClick={onImageClick}
                    />
                ))}
            </div>
        );
    }
};

const ImageCard = ({ label, src, onClick }) => (
    <div style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ backgroundColor: '#f7f7f7', padding: '8px', fontSize: '0.85rem', fontWeight: 'bold', textAlign: 'center', borderBottom: '1px solid #eee' }}>{label}</div>
        <div style={{ height: '150px', backgroundColor: '#eee', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: src ? 'pointer' : 'default' }} onClick={() => src && onClick(src)}>
            {src ? <img src={src} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ color: '#aaa', fontSize: '0.8rem' }}>이미지 없음</span>}
        </div>
    </div>
);

const controlBtnStyle = {
    width: '25px', height: '25px', borderRadius: '4px', border: 'none',
    backgroundColor: 'rgba(0,0,0,0.6)', color: 'white', cursor: 'pointer',
    display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1.2rem', fontWeight: 'bold'
};

const DetailRow = ({ label, value, isBold = false, color = 'black' }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <label style={{ width: '30%', fontWeight: 'bold', color: '#555', fontSize: '0.95rem' }}>{label}</label>
        <div style={{ width: '65%', textAlign: 'right', wordBreak: 'break-all', fontWeight: isBold ? 'bold' : 'normal', color: color, fontSize: '0.95rem' }}>{value || '-'}</div>
    </div>
);

const ConfirmRow = ({ label, confirmer, onConfirm, onView, showViewButton = true }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label style={{ width: '30%', fontWeight: 'bold', color: '#333', fontSize: '0.95rem' }}>{label}</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', width: '65%', justifyContent: 'flex-end' }}>
            {showViewButton && (
                <span onClick={onView} style={{ color: '#006edc', textDecoration: 'underline', cursor: 'pointer', fontSize: '0.9rem' }}>첨부보기</span>
            )}
            {confirmer ? (
                <span style={{ color: '#006edc', fontWeight: 'bold', minWidth: '50px', textAlign: 'center' }}>{confirmer}</span>
            ) : (
                <button onClick={onConfirm} style={{ padding: '5px 15px', backgroundColor: 'white', color: '#006edc', border: '1px solid #006edc', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 'bold' }}>확인</button>
            )}
        </div>
    </div>
);

const FilterContainer = styled.div`
    display: flex; justify-content: flex-end; width: 90%; margin: 10px auto 10px auto; gap: 15px;
    .checkbox-label { display: flex; alignItems: center; fontSize: 0.9rem; cursor: pointer; fontWeight: bold; }
    input[type="checkbox"] { margin-right: 5px; width: 16px; height: 16px; cursor: pointer; }
    .indicator { width: 10px; height: 10px; borderRadius: 50%; marginRight: 5px; display: inline-block; }
    .indicator.apply { background-color: #006edc; }
    .indicator.complete { background-color: #28a745; }
    .indicator.reject { background-color: #dc3545; }
`;

// ✅ 달력 스타일 수정 (세로 배치, 날짜와 마커 겹침 해결)
const CalendarWrapper = styled.div`
  width: 90%; margin: 0 auto 20px auto; display: flex; justify-content: center;
  .react-calendar { width: 100% !important; max-width: 100% !important; background: white; border: 1px solid #e2e2e2; font-family: 'Pretendard', sans-serif; line-height: 1.125em; border-radius: 8px; padding: 10px; }
  .react-calendar__navigation { display: flex; height: 100px; margin-bottom: 10px; }
  .react-calendar__navigation button { min-width: 0; font-size: 2rem; flex-grow: 1; width: 33.333%; }
  .react-calendar__navigation__label { font-size: 1.5rem; font-weight: bold; flex-grow: 1; width: 33.333%; }
  .react-calendar__month-view__weekdays { font-weight: bold; fontSize: 1.1rem; text-decoration: none; }
  .react-calendar__month-view__weekdays__weekday abbr { text-decoration: none; }
  
  /* 타일 레이아웃: 세로 정렬 강제, 상단 정렬 */
  .react-calendar__tile { 
    height: 120px; 
    display: flex; 
    flex-direction: column; 
    justify-content: flex-start !important; 
    align-items: center; 
    padding: 10px 0 !important; 
    border-bottom: 1px solid #eee; 
    position: relative; 
    overflow: hidden; 
  }

  /* 날짜 숫자: 마커와 간격을 띄움 */
  .react-calendar__tile > abbr { 
    display: block; 
    width: 100%; 
    text-align: left; 
    padding-left: 8px; 
    margin-bottom: 8px; /* 간격 확보 */
    font-size: 1rem; 
    font-weight: bold; 
    flex-shrink: 0; 
  }

  .react-calendar__month-view__days__day--weekend { color: #d10000; background: #feb7b7ff; }
  .react-calendar__month-view__days__day--weekend:nth-child(7n) { color: #006edc; background: #b3d9ffff; }
  .react-calendar__tile--now { background: #ffffcc !important; color: black; }
  .react-calendar__tile--active { background: #006edc !important; color: white !important; }
  .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus { background: #1087ff !important; }
  
  /* 마커 컨테이너: 세로 정렬 */
  .marker-container { 
    display: flex; 
    flex-direction: column; 
    gap: 3px; 
    width: 100%; 
    align-items: center; 
    margin-top: 2px; 
  }
  
  /* 마커 스타일 */
  .calendar-marker { 
    fontSize: 0.75rem; 
    fontWeight: bold; 
    padding: 3px 0; 
    borderRadius: 4px; 
    width: 90%; 
    textAlign: center; 
    whiteSpace: nowrap; 
    overflow: hidden; 
    textOverflow: ellipsis; 
    color: white; 
    lineHeight: 1.2; 
  }
  .marker-apply { background-color: #006edc; }
  .marker-complete { background-color: #28a745; }
  .marker-reject { background-color: #dc3545; }
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 20px; padding-bottom: 20px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li { display: inline-block; width: 30px; height: 30px; border: 1px solid #e2e2e2; display: flex; justify-content: center; align-items: center; font-size: 1rem; margin: 0 2px; cursor: pointer; }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; border-color: #337ab7; }
`;

export default Biling;